import { TMerchantAddress } from 'shared/types';

export const parseAddress = (address: TMerchantAddress): string => {
    const { street, city, country, postal_code, region } = address;

    const parts = [
        street && street + ',',
        city,
        region && region + ',',
        postal_code,
        country,
    ].filter(Boolean);

    return parts.length ? parts.join(' ') : '';
};
